import { createReducer } from "@reduxjs/toolkit";
import { GetActionPlanCountAsync, getSupplierActionPlanListSuccess, saveActionPlanListSuccess } from "./actionPlanAction";
import { ActionPlanCountMap } from "src/models/actionPlan.model";

export interface IActionPlanState {
  supplierActionPlanList: Array<any>;
  dataCount: number;
  isLoading: boolean;
  actionPlanCounts?: ActionPlanCountMap;
}

const initialState: IActionPlanState = {
  supplierActionPlanList: [],
  dataCount: 0,
  isLoading: false,
};

export const actionPlanReducer = createReducer(initialState, (builder) => {
  builder

   .addCase(getSupplierActionPlanListSuccess, (state, action) => {
      state = {
        ...state,
        supplierActionPlanList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(saveActionPlanListSuccess, (state, action) => {
          state = {
            ...state,
            supplierActionPlanList: action.payload,
          };
          return state;
        })
    .addCase(GetActionPlanCountAsync.fulfilled, (state, action) => {
          let data = {
            ...state.actionPlanCounts,
            ...action.payload,
          };
          state = {
            ...state,
            actionPlanCounts: data,
          };
          console.log("1234",state.actionPlanCounts);
          return state;
        })
});
